(() => {
  function mount(root) {
    if (root.dataset.mounted) return;
    root.dataset.mounted = 'true';
    const film = root.querySelector('video');
    const messages = [...root.querySelectorAll('.tilda-message')];
    const dots = [...root.querySelectorAll('.tilda-dot')];
    const toggle = root.querySelector('.tilda-play');
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const signal = new AbortController();
    const interval = Math.max(5000, Number(root.dataset.interval) || 7000);
    let index = 0, timer = null, paused = motion.matches, visible = true;
    function show(n) {
      index = (n + messages.length) % messages.length;
      messages.forEach((m, i) => {
        m.classList.toggle('is-active', i === index);
        m.setAttribute('aria-hidden', String(i !== index));
        m.inert = i !== index;
        dots[i].classList.toggle('is-active', i === index);
        dots[i].setAttribute('aria-pressed', String(i === index));
      });
    }
    function stopTimer() { clearInterval(timer); timer = null; }
    function update() {
      stopTimer();
      const running = !paused && visible && !document.hidden;
      toggle.textContent = paused ? 'Play' : 'Pause';
      toggle.setAttribute('aria-label', paused ? 'Play background video and text rotation' : 'Pause background video and text rotation');
      if (running) {
        if (film && !film.error) film.play().catch(() => {
          paused = true; stopTimer();
          toggle.textContent = 'Play';
          toggle.setAttribute('aria-label', 'Play background video and text rotation');
        });
        timer = setInterval(() => show(index + 1), interval);
      } else if (film) film.pause();
    }
    root.querySelector('.tilda-controls').hidden = false;
    toggle.addEventListener('click', () => { paused = !paused; update(); }, { signal: signal.signal });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); update(); }, { signal: signal.signal }));
    if (film) {
      film.muted = true;
      film.setAttribute('aria-hidden', 'true');
      film.addEventListener('playing', () => film.classList.add('is-ready'), { signal: signal.signal });
      film.addEventListener('error', () => film.classList.remove('is-ready'), { signal: signal.signal });
    }
    document.addEventListener('visibilitychange', update, { signal: signal.signal });
    motion.addEventListener('change', () => { paused = motion.matches; update(); }, { signal: signal.signal });
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; update(); }, { threshold: 0.08 });
    observer.observe(root.querySelector('.tilda-cinema'));
    root.tildaDestroy = () => { signal.abort(); stopTimer(); observer.disconnect(); if (film) film.pause(); delete root.dataset.mounted; };
    show(0); update();
  }
  const scan = () => document.querySelectorAll('[data-tilda-launch]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true }); else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-tilda-launch]').forEach(root => root.tildaDestroy?.()));
})();
